import script from "./PaymentDisabledView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentDisabledView.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentDisabledView.vue?vue&type=style&index=0&id=27ca27d0&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ca27d0"]])

export default __exports__